import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import { mutationsBuilder, mutationFormat } from '@u/vuexHelper';
//modules
import cache from './modules/cache';
const { token, refreshToken, refreshTokenID } = cache.state;
//
import i18n from '@/lang/index';
//api
import { getRefreshToken, getRefreshTokenAxios, otpLogin } from "@/api/auth";
import { getUserMe } from "@/api/userMe";
import { getChannels } from "@/api/channel";
import { setNotifyToken } from "@/api/notifyToken";

Vue.use(Vuex);
const state = {
  //auth
  isLogin: !!(token && refreshToken && refreshTokenID),
  userInfo: undefined,
  //
  lang: localStorage.getItem('VUEX_LANG') || 'tw',
  messageBox_ready: false,
  pageLoading: 0,
  isDocumentReady: false,
  confirm: {
    show: false,
    type: '', //confirm, delete
    title: '',
    text: '',
    label_submit: '',
    label_cancel: '',
    submit: () => { },
    close: () => { },
  },
  //WebInterface
  activeTime: Date.now(),
  messageTime: Date.now(),
};
const mutations = mutationsBuilder(state);
mutations['ADD_PAGE_LOADING'] = function (state, value) {
  let result = state.pageLoading + value;
  state.pageLoading = result >= 0 ? result : 0;
};
const actions = {
  async GetRefreshToken({ commit, state, getters }, isAxios = false) {
    if (!state.isLogin) return;

    try {
      const callFunction = isAxios ? getRefreshTokenAxios : getRefreshToken;
      let res = await callFunction({
        refreshToken: getters.refreshToken,
        refreshTokenID: getters.refreshTokenID
      })
      if (isAxios) {
        res = res.data;
      }
      console.log('GetRefreshToken Res', res);

      commit("cache/SET_TOKEN", res.data.idToken);
      commit("cache/SET_REFRESH_TOKEN", res.data.refreshToken);
      commit("cache/SET_REFRESH_TOKEN_ID", res.data.refreshTokenID);

      // 保存 token 過期時間
      const expirationTime = Date.now() + res.data.expiresIn * 1000;
      commit("cache/SET_TOKEN_EXPIRATION_TIME", expirationTime);

      appCallSaveStorage({
        key: 'userInfo',
        value: {
          token: res.data.idToken,
          refreshToken: res.data.refreshToken,
          refreshTokenID: res.data.refreshTokenID,
        }
      });
      appCallSaveStorage({
        key: 'tokenExpirationTime',
        value: expirationTime
      });

      // 給 tokenRefreshService 用的
      return Promise.resolve(isAxios ? res.data : res);
    } catch (error) {
      console.log('GetRefreshToken Error', error);
      // NOTIFICATION("e", error?.message || "系統錯誤");
      return Promise.reject(error);
    }
  },
  async OtpLogin({ commit }, { email, otp }) {
    try {
      const res = await otpLogin({ email, otp });
      commit("cache/SET_TOKEN", res.data.idToken);
      commit("cache/SET_REFRESH_TOKEN", res.data.refreshToken);
      commit("cache/SET_REFRESH_TOKEN_ID", res.data.refreshTokenID);

      // 保存 token 過期時間
      const expirationTime = Date.now() + res.data.expiresIn * 1000;
      commit("cache/SET_TOKEN_EXPIRATION_TIME", expirationTime);

      appCallSaveStorage({
        key: 'userInfo',
        value: {
          token: res.data.idToken,
          refreshToken: res.data.refreshToken,
          refreshTokenID: res.data.refreshTokenID,
        }
      });

      appCallSaveStorage({
        key: 'tokenExpirationTime',
        value: expirationTime
      });

      commit("SET_IS_LOGIN", true);

      await setNotifyToken();
    } catch (error) {
      NOTIFICATION("e", error?.message || i18n.t("auth.loginFailed"));
      commit("SET_IS_LOGIN", false);
      throw error;
    }
  },
  async GetUserInfo({ commit }) {
    try {
      const res = await getUserMe();
      if (res) {
        res.data.images = res.data.images || [];
        res.data.imageUrl = res.data.images?.[0]?.url;
        commit("SET_USER_INFO", res.data);
        return res.data;
      }
      return null;
    } catch (error) {
      throw error;
    }
  },
  async GetChannels({ commit }, LOADING) {
    try {
      const res = await getChannels(LOADING);

      if (res && res.data) {
        commit("cache/SET_CHANNELS", res.data);
      }
    } catch (error) {
      throw error;
    }
  }
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    cache,
  },
  getters,
});
